import React, { useEffect, useState, useContext } from "react";
import imxtools from "imxtools";
import Tag from "../Tag";
import "./index.scss";
import DragPage from "../../../../../ComponentsLibrary/DragPage";
import DropTargetBody from "../../DropTargetBody";
import { isSelectedComponent } from "../../../services/isSelectedComponent";
import { handleComponentProp } from "../../../services/handleComponentProperties";
import { useSelector, useStore } from "react-redux";
import { AppContext } from "../../../../../../services/AppContext";

function HeaderBody({
  data = {},
  path = [],
  parentPath = [],
  readOnly = true,
  currentPath = [],
}) {
  const [dataTags, setDataTags] = useState([]);
  let store = useStore();

  const language = useSelector(
    (state) => state?.entities?.deviceview?.settings?.language || "en"
  );

  useEffect(() => {
    setDataTags(imxtools?.toArray(data?.tag ? data?.tag : []));
  }, [data]);
  const { setBodyHeader, bodyHeader } = useContext(AppContext);
  return (
    <DropTargetBody
      className={`body-header-container ${
        isSelectedComponent(readOnly, [...parentPath, "header"], currentPath) &&
        "selectedComponent"
        // : !readOnly && "unSelectedComponent"
      } ${!readOnly && "hovered"}`}
      style={{
        flexDirection: language?.toLowerCase() === "ar" && "row-reverse",
      }}
      accept={["tag"]}
      dragParent={[...path, "tag"]}
      onClick={(e) => {
        handleComponentProp(e, null, data?.header, parentPath, store, "header");
        setBodyHeader(true);
      }}
    >
      {dataTags?.length > 0 ? (
        dataTags?.map((tag, index) => {
          const numTags = imxtools?.toArray(data?.tag)?.length;
          return (
            <React.Fragment key={index}>
              <DragPage
                index={index}
                className={`drag-tag-content ${
                  isSelectedComponent(
                    readOnly,
                    numTags > 1
                      ? [...path, "tag", index?.toString()]
                      : [...path, "tag"],
                    currentPath
                  ) && `selectedComponent`
                }`}
                component={"tag"}
                dragParentPath={[...path, "tag"]}
                dragData={tag}
                dataAttributes={dataTags}
                setDataAttributes={setDataTags}
              >
                <Tag
                  key={index}
                  data={tag}
                  path={path}
                  index={index}
                  numTags={numTags}
                />
              </DragPage>
            </React.Fragment>
          );
        })
      ) : (
        <div className="body-header-empty">Add tag</div>
      )}
    </DropTargetBody>
  );
}

export default HeaderBody;
